export default __webpack_public_path__ + "static/media/xmines_nathanyell_frustrated.c0ef39d7.mp3";